// extracted by mini-css-extract-plugin
export default {"container":"_1f3bcad8","title":"_e905f4df","returnPolicyContainer":"_41e08672"};